// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".article-most-viewed__wrapper .article-most-viewed__list-item[data-v-4a1c0af4]{margin-bottom:20px}.article-most-viewed__wrapper .article-most-viewed__list-item[data-v-4a1c0af4]:last-child{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
